import { makeAutoObservable } from 'mobx'
import { type RootStore, useRootStore } from 'stores/RootStore'

export class LayoutStore {
  private _rightColumn: HTMLDivElement | null
  private _rightColumnLocked: boolean = false
  private _rightColumnIsHovered: boolean = false
  private _writerToolbar: HTMLDivElement | null
  private _postPreview: HTMLDivElement | null
  private _mobileWriterToolbar: HTMLDivElement | null
  private _viewport: HTMLDivElement | null
  private _dashboardContent: HTMLDivElement | null

  rootStore: RootStore

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore
    this._rightColumn = null
    this._writerToolbar = null
    this._postPreview = null
    this._mobileWriterToolbar = null
    this._viewport = null
    this._dashboardContent = null
    makeAutoObservable(this)
  }

  setDashboardContent(node: HTMLDivElement | null) {
    this._dashboardContent = node
  }

  get dashboardContent() {
    return this._dashboardContent
  }

  setRightColumn(node: HTMLDivElement | null) {
    this._rightColumn = node
  }

  get rightColumn() {
    return this._rightColumn
  }

  setWriterToolbar(node: HTMLDivElement | null) {
    this._writerToolbar = node
  }

  get writerToolbar() {
    return this._writerToolbar
  }

  get postPreview() {
    return this._postPreview
  }

  setPostPreview(node: HTMLDivElement | null) {
    this._postPreview = node
  }

  setMobileWriterToolbar(node: HTMLDivElement | null) {
    this._mobileWriterToolbar = node
  }

  get mobileWriterToolbar() {
    return this._mobileWriterToolbar
  }

  get rightColumnLocked() {
    return this._rightColumnLocked
  }

  get rightColumnIsHovered() {
    return this._rightColumnIsHovered
  }

  setRightColumnHovered(isHovered: boolean) {
    this._rightColumnIsHovered = isHovered
  }

  setRightColumnLocked(isLocked: boolean) {
    this._rightColumnLocked = isLocked
  }

  setViewport(node: HTMLDivElement | null) {
    this._viewport = node
  }

  get viewport() {
    return this._viewport
  }
}

export const useLayout = () => {
  const rootStore = useRootStore()
  return rootStore.layout
}
